// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  displayMessage(event) {
    $('#gift_credit_transaction_gift_credit_invitation_attributes_message').show()
    $('#msg_link').hide()
  }
}
